// TODO (webpack v5): drop the `build/package/` part of these import paths.
// Snabbdom>=1 uses the package.json#exports field that webpack v4 doesn't know
// about
//
// https://github.com/webpack/webpack/issues/9509
// https://webpack.js.org/guides/package-exports/
import {toVNode} from 'snabbdom/build/package/tovnode';
import {toVNodeFromServerSideRenderedNode} from './utils/toVNodeFromServerSideRenderedNode';
import {sign} from 'snabbdom-signature';

/**
 * Creates an element for the virtual DOM from an existing DOM node
 * @method createElementFromNode
 * @param {Node} node DOM node to convert
 * @returns {VNode} The vnode to use in the virtual DOM
 */
export default function createElementFromNode(node) {
	const vnode = sign(toVNode(node));
	fixNamespace(vnode); // fixes issue with missing namespace for svgs: https://github.com/snabbdom/snabbdom/issues/388
	return vnode;
}

/**
 * Create a vdom tree from an existing DOM node which has been server-side rendered
 * @method createElementFromServerSideRenderedNode
 * @param {Node} node DOM node to convert
 * @returns {VNode} The vnode to use in the virtual DOM
 */
export function createElementFromServerSideRenderedNode(node) {
	const vnode = toVNodeFromServerSideRenderedNode(node);
	if (
		node instanceof DocumentFragment &&
		vnode.children.length === 0 &&
		node.childNodes.length > 0
	) {
		// snabbdom still doesn't handle DocumentFragment correctly
		// so we need to manually add the children
		const {length: childrenCount} = node.childNodes;
		for (let i = 0; i < childrenCount; i++) {
			const childVNode = toVNodeFromServerSideRenderedNode(node.childNodes[i]);
			// skip the nullified child node if it has non-falsy NOW_EXCLUDED_FROM_HYDRATION_ATTR attribute
			if (childVNode) {
				vnode.children.push(childVNode);
			}
		}
	}
	const signedVnode = sign(vnode);
	fixNamespace(signedVnode); // fixes issue with missing namespace for svgs: https://github.com/snabbdom/snabbdom/issues/388
	return signedVnode;
}

const fixNamespace = (vnode, xmlns = vnode.data && vnode.data.attrs && vnode.data.attrs.xmlns) => {
	const {children, data} = vnode;

	if (data && !data.ns && xmlns) data.ns = xmlns;

	if (children) {
		const {length: childrenCount} = children;
		for (let i = 0; i < childrenCount; i++) fixNamespace(children[i], xmlns);
	}
};
